import {FC, useEffect, useLayoutEffect, useRef, useState} from 'react';
import {api, LocalEventEmitter, MS_PER_CHAR, useT} from '@kcast-fe/core';
import {Box} from '@chakra-ui/react';
import {ErrorBoundary} from 'ui-kit';

import {MarkdownContent} from './components';

interface IProps {
  text: string;
  isMyMsg: boolean;
  isFinal: boolean;
  withPadding: boolean;
}

const RenderMarkdownFC: FC<IProps> = ({text, isFinal, isMyMsg, withPadding}) => {
  const [visibleLength, setVisibleLength] = useState(isFinal ? text.length : 0);

  const {data: settings} = api.settings.useSettingsQuery();
  const {t} = useT();

  const msPerChar = settings?.typewriter_settings?.ms_per_char ?? MS_PER_CHAR;

  const isTyping = useRef<boolean>(false);
  const typingTimer = useRef<NodeJS.Timeout | undefined>(undefined);

  // NEW UPDATED MESSAGE
  useEffect(() => {
    if (visibleLength < text.length) {
      isTyping.current = true;
      clearTimeout(typingTimer.current);

      typingTimer.current = setTimeout(() => {
        setVisibleLength(visibleLength + 1);
      }, msPerChar);
    } else {
      isTyping.current = false;
    }
  }, [visibleLength, text.length, msPerChar]);

  useLayoutEffect(() => {
    if (isTyping.current) {
      LocalEventEmitter.emit('ChatScrollToEnd');
    }
  }, [visibleLength, isFinal]);

  return (
    <ErrorBoundary
      msg={t('errors.msgParseError')}
      styles={{opacity: 0.5, fontSize: '12px', height: '30px', padding: '6px 0'}}
    >
      <Box
        userSelect={'text'}
        p={withPadding ? '12px 16px 0 16px' : 0}
        className={`markdown ${isMyMsg ? 'is-my' : ''}`}
      >
        <MarkdownContent text={text.substring(0, visibleLength)} />
      </Box>
    </ErrorBoundary>
  );
};

export const RenderMarkdown = RenderMarkdownFC;
